// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CkaPP","heading":"styles_heading__uewJl","infoContainer":"styles_infoContainer__UUz9Y","infoText":"styles_infoText__DcMMx"};